import type { ReactNode } from 'react';

type SectionIntroProps = {
  title?: ReactNode;
  description?: ReactNode;
};

export function SectionIntro({ title, description }: SectionIntroProps) {
  if (!title && !description) {
    return null;
  }

  return (
    <div className="flex w-full flex-col gap-[2.25rem]">
      {title}
      {description}
    </div>
  );
}
